import React from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { MuiThemeProvider } from "@material-ui/core/styles";

import LoadingButton from "../LoadingButton";
import temaFormulario from "../../Styles/Temas/temaFormulario";

export default function ModalExclusao({
    open = false,
    onConfirma = () => { },
    onCancela = () => { },
    loading = false,
    titulo = 'Excluir',
    texto = 'Deseja mesmo excluir?',
    textoComponent = null
}) {
    return (
        <MuiThemeProvider theme={temaFormulario}>
            <Dialog
                open={open}
                onClose={() => { if (!loading) { onCancela() } }}
                aria-labelledby="modal-exclusao"
            >
                <DialogTitle id="modal-exclusao">
                    {titulo}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{ wordBreak: "break-word" }}>
                        {textoComponent !== null ? textoComponent : texto}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        id="button_cancelar-exclusao"
                        variant="text"
                        onClick={onCancela}
                        disabled={loading}
                    >
                        Cancelar
                    </Button>
                    <LoadingButton
                        id="button_confirmar-exclusao"
                        variant="contained"
                        color="secondary"
                        style={{backgroundColor: '#ff604f'}}
                        startIcon={<DeleteIcon />}
                        onClick={onConfirma}
                        loading={loading}
                    >
                        Apagar
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </MuiThemeProvider>
    );
}
